import React, { useState, useEffect } from 'react';
import { authenticatedUser } from '../../../authentication/authModule';
import { UserRole } from '../../../models/enums/UserRole';
import CSVGeneratorButton from '../../common/CSVGeneratorButton';
import CheckboxFilter, { CheckboxOption } from '../../common/tables/CheckboxFilter';
import Filter from '../../common/tables/Filter';
//import ExportColumns from './SubscriptionsHomeExport';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import './AWSAccountsHome.css';
import ResourceTabs from '../../common/ResourceTabs';
import Organization from '../../../models/entities/Organization';
import AWSAccountRequest from '../../../models/entities/AWSAccountRequest';
import { Button, Select } from '../../common';
import { ButtonGroup } from '../../common/components/ButtonGroup';
import { Icon } from '../../common/components/Icon';
import { Toolbar, ToolbarItem } from '../../common/components/Toolbar';
import { Searchbar } from '../../common/components/Searchbar';

type AWSAccountsFilters = {
	searchGeneral: string;
	status: CheckboxOption[];
	l3Organization: CheckboxOption[];
	type: CheckboxOption[];
	azureState: CheckboxOption[];
	dateRangeFrom: Date;
	dateRangeTo: Date;
	searchTenantName: CheckboxOption[];
	showResources: string;
	orderBy: string;
	importStatus: CheckboxOption[];
};

interface AWSAccountsHomeFiltersProps {
	setFilteredAWSAccounts: any;
	areMyAccountsLoading: boolean;
	areAllAccountsLoading: boolean;
	filteredAWSAccounts: AWSAccountRequest[];
	fetchAccounts: any;
	allAWSAccounts: AWSAccountRequest[];
	parentOrganizationsList: Organization[];
}

const AWSAccountsHomeFilters = ({
	setFilteredAWSAccounts,
	areMyAccountsLoading,
	areAllAccountsLoading,
	filteredAWSAccounts,
	fetchAccounts,
	allAWSAccounts,
	parentOrganizationsList,
}: AWSAccountsHomeFiltersProps) => {
	const navigate = useNavigate();
	const resourceTabs = [];
	const parentOrgs = [];

	parentOrganizationsList.forEach((org) => {
		parentOrgs.push({
			label: org.shortName,
			value: org.shortName,
			checked: true,
		});
	});
	//adding Others option for AWSAccounts that are still assigned to old Orgs
	parentOrgs.push({
		label: 'Others',
		value: 'Others',
		checked: true,
	});
	resourceTabs.push({
		item1: `My AWS Accounts`,
		item2: null,
	});
	// authenticatedUser.isInRole(UserRole.OrgAdmins) &&
	// 	resourceTabs.push({
	// 		item1: `Admin AWS Accounts`,
	// 		item2: null,
	// 	});
	resourceTabs.push({
		item1: `All AWS Accounts`,
		item2: null,
	});
	const defaultFilters = {
		searchGeneral: '',
		status: [
			{ label: 'Completed', value: 'Completed', checked: true },
			{ label: 'Rejected', value: 'Rejected', checked: true },
			{ label: 'Deleted', value: 'Deleted', checked: true },
			{ label: 'Error', value: 'Error', checked: true },
			{ label: 'Awaiting Implementation', value: 'Awaiting Implementation', checked: true },
			{ label: 'Awaiting Changes Implementation', value: 'Awaiting Changes Implementation', checked: true },
			{ label: 'Pending Account owner approval', value: 'Pending Account owner approval', checked: true },
			{ label: 'Pending DMZ Implementation', value: 'Pending DMZ Implementation', checked: true },
			{ label: 'Pending Tier0 Architect Approval', value: 'Pending Tier0 Architect Approval', checked: true },
			{ label: 'Pending Vault Team Approval', value: 'Pending Vault Team Approval', checked: true },

			{ label: 'Pending Aws Connectivity Details', value: 'Pending Aws Connectivity Details', checked: true },
			{
				label: 'Pending Platforms Architect approval',
				value: 'Pending Platforms Architect approval',
				checked: true,
			},
			{
				label: 'Pending Platforms Delivery Architect approval',
				value: 'Pending Platforms Delivery Architect approval',
				checked: true,
			},
			{ label: 'Awaiting deletion', value: 'Awaiting Deletion', checked: true },
			{ label: 'Expired', value: 'Expired', checked: true },

		],
		l3Organization: parentOrgs,
		type: [
			{ label: 'Managed', value: 'Managed', checked: true },
			{ label: 'Disconnected', value: 'Disconnected', checked: true },
		],
		dateRangeFrom: new Date('January 01, 2000 23:15:30'),
		dateRangeTo: new Date(),
		showResources: 'My AWS Accounts',
		orderBy: 'newest',
		importStatus: [
            { label: 'Standard', value: 'standard', checked: true },
            { label: 'Imported', value: 'imported', checked: true },

        ],
	} as AWSAccountsFilters;

	const filterAWSAccounts = () => {
		let filtered = [];

		const filterCallback = (acc: AWSAccountRequest) => {
			if (!acc?.workflowInstance?.currentWorkflowInstanceState?.workflowState) {
				return false;
			}
			
			return (
				filter.filterCheckBox('importStatus', acc.isImportedAccount() ? 'imported' : 'standard') &&
				filter.filterCheckBox('status', acc.workflowInstance.currentWorkflowInstanceState.workflowState.name) &&
				(filterOthersOption('l3Organization', acc.organization?.L3?.shortName ?? '(No organization)') ||
					filter.filterCheckBox('l3Organization', acc.organization?.L3?.shortName ?? '(No organization)')) &&
				filter.filterCheckBox('type', acc.isManaged ? 'Managed' : 'Disconnected') &&
				(filter.filterSearchText('searchGeneral', acc.createdAccountId) ||
					filter.filterSearchText('searchGeneral', acc.accountName) ||
					filter.filterSearchText('searchGeneral', acc.owner?.displayName) ||
					filter.filterSearchText('searchGeneral', acc.custodian?.displayName) ||
					filter.filterSearchText('searchGeneral', acc.accountUsedFor)
				) //||
				// (acc.cartaIds.length > 0 &&
				// 	filter.filterSearchTextInArray('searchGeneral', acc.cartaIds, 'cartaAppId'))) //&&
				//filter.filterDateRange('dateRangeFrom', 'dateRangeTo', acc.workflowInstance.createdDate)
			);
		};
		//Filter added for the aws accounts that are still assigned to old organizations
		const filterOthersOption = (filterOption: string, value: String) => {
			let test = filter.defaultFilters[filterOption].find(
				(filter) => filter.value === 'Others' && filter.checked === true
			)
				? true
				: false;
			return test ? !parentOrgs.some((str) => str.value === value) : false;
		};

		filtered = allAWSAccounts.filter(filterCallback);

		if (filter.filters.showResources == 'My AWS Accounts') {
			filtered = filtered.filter(
				(acc: AWSAccountRequest) =>
					acc?.owner?.id === authenticatedUser.userId || acc?.custodian?.id === authenticatedUser.userId
			);
		}

		// if (filter.filters.showResources == 'Admin AWS Accounts') {
		// 	filtered = filtered.filter(
		// 		(acc: AWSAccountRequest) =>
		// 			isOrgAdmin && authenticatedUser.myL3Orgs.includes(acc.organization?.L3?.displayName)
		// 	);
		// }

		const nullState = 'Not Available';
		filtered.sort((a, b) => {
			const aa = a?.azureState ? a.azureState : nullState;
			const bb = b?.azureState ? b.azureState : nullState;
			if (aa === bb) {
				return filter.filters.orderBy === 'newest'
					? moment(b?.workflowInstance?.createdDate).valueOf() -
							moment(a?.workflowInstance?.createdDate).valueOf()
					: moment(a?.workflowInstance?.createdDate).valueOf() -
							moment(b?.workflowInstance?.createdDate).valueOf();
			}
			if (aa === 'Enabled') return -1;
			if (bb === 'Enabled') return 1;
			if (aa > bb) return 1;
			if (aa < bb) return -1;
			return 0;
		});

		setFilteredAWSAccounts(filtered);
	};

	useEffect(() => {
		filter.updateFilterFunction(filterAWSAccounts);
	}, [allAWSAccounts]);

	useEffect(() => {
		filter.filter();
	}, []);

	const [filter] = useState<Filter<AWSAccountsFilters>>(new Filter(filterAWSAccounts, defaultFilters));

	const handleRefresh = () => {
		filter.updateFilter('My AWS Accounts', 'showResources');
		fetchAccounts(true);
	};

	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	return (
		<>
			{filter && (
				<>
					<ResourceTabs
						allResources={resourceTabs}
						filter={filter}
						disabled={areMyAccountsLoading || areAllAccountsLoading}
					/>
					<Toolbar>
						<ToolbarItem stretched>
							<Searchbar
								className="searchbar-width"
								condensed
								onClick={clearSearchbar}
								placeholder="Search (i.e. AWS Account Name, Intended Usage, Type, etc.)"
								value={filter.filters.searchGeneral}
								onChange={(e) => filter.handleSearchTextChange(e, 'searchGeneral')}
							/>
						</ToolbarItem>
						<ToolbarItem right>
							<ButtonGroup>
								{(authenticatedUser.isInRole(UserRole.AWSDisconnectedAccountRequestor) ||
									authenticatedUser.isInRole(UserRole.AWSManagedAccountRequestor)) && (
									<Button
										variant="primary"
										size="small"
										onClick={() => {
											navigate('/awsAccounts/new');
										}}
									>
										<Icon size="small" icon={'plus'} />
										<span>Request AWS Account</span>
									</Button>
								)}
								{/* {authenticatedUser.isInRole(UserRole.AWSAccountAdmin) && (
									<Button
										variant="primary"
										size="small"
										onClick={() => {
											navigate('/awsAccounts/import');
										}}
									>
										<CheckInDoc2Icon size="small" />
										<span>Import AWS Account</span>
									</Button>
								)} */}
								{/* <CSVGeneratorButton data={filteredAWSAccounts} columns={ExportColumns} /> */}
								<Button variant="secondary" size="small" onClick={handleRefresh}>
									<Icon size="small" icon={'refresh'} />
									<span> Refresh</span>
								</Button>
							</ButtonGroup>
						</ToolbarItem>
					</Toolbar>

					<Toolbar>
						<ToolbarItem>
							<CheckboxFilter
								label="Type"
								onChange={(event) => filter.handleCheckboxChange(event, 'type')}
								options={filter.filters.type}
								allDefaultChecked={true}
							/>
						</ToolbarItem>
						<ToolbarItem>
							<CheckboxFilter
								label="Status"
								buttonProps={{ size: 'small' }}
								onChange={(event) => filter.handleCheckboxChange(event, 'status')}
								options={filter.filters.status}
							/>
						</ToolbarItem>
						<ToolbarItem>
							<CheckboxFilter
								label="Organization"
								onChange={(event) => filter.handleCheckboxChange(event, 'l3Organization')}
								options={filter.filters.l3Organization}
								allDefaultChecked={true}
							/>
						</ToolbarItem>
						<ToolbarItem>
							<CheckboxFilter
								label="Tenant Name"
								onChange={(event) => filter.handleCheckboxChange(event, 'searchTenantName')}
								options={filter.filters.searchTenantName}
								allDefaultChecked={true}
							/>
						</ToolbarItem>
						<ToolbarItem>
							<span
								className="clear-filters"
								onClick={() =>
									filter.updateFilters({
										...defaultFilters,
										showResources: filter.filters.showResources,
									})
								}
							>
								Clear filters
							</span>
						</ToolbarItem>
						<ToolbarItem right>
							<ButtonGroup>
								<p className="sort-by-p">Sort by</p>
								<Select
									// style={{ marginBottom: -10, cursor: 'pointer' }}
									value={filter.filters.orderBy}
									onChange={(e) => filter.handleSearchTextChange(e, 'orderBy')}
									options={[
										{ text: 'Newest', value: 'newest' },
										{ text: 'Oldest', value: 'oldest' },
									]}
								></Select>
							</ButtonGroup>
						</ToolbarItem>
					</Toolbar>
				</>
			)}
		</>
	);
};

export default AWSAccountsHomeFilters;
